import template from './mainMenuMobile.html';
import controller from './mainMenuMobile.controller';
import './mainMenuMobile.scss';

let mainMenuMobileComponent = {
  restrict: 'E',
  bindings: {
    links: '<',
    employeeInfo: '<',
    managerInfo: '<',
    module: '@',
    isMobileApp: '<',
    showLinks: '<',
  },
  template,
  controller
};

export default mainMenuMobileComponent;



// WEBPACK FOOTER //
// ./client/app/components/mainMenuMobile/mainMenuMobile.component.js